import React from 'react';
import PropTypes from 'prop-types';
import Tab from 'react/containers/layout/tabs/Tab';
import IntegrationsContainer from 'react/components/Integrations/IntegrationsContainer';

class Integrations extends Tab {
  static propTypes = {
    active: PropTypes.bool
  }

  static tabName = 'Integrations'

  activeClassName = 'is-active'

  render() {
    const { active } = this.props;
    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;

    return (
      <div className={className}>
        <IntegrationsContainer />
      </div>
    );
  }
}

export default Integrations;
